<template>
  <div>
    <v-select
      v-model="selected"
      :items="items"
      item-value="id"
      item-text="label"
      :item-disabled="isItemDisabled"
      chips
      outlined
      dense
      :clearable="clearable"
      label="Ungrouped Scheduled Products"
      multiple
      menu-props="auto, overflowX, overflowY"
      hide-details
      small-chips
      @change="$emit('change-selected', selected)"
    />
  </div>

</template>

<script>
import { isEmpty } from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    initSelected: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([ 'getScheduledProducts' ]),
    items() {
      return [ ...this.getScheduledProducts ]
    },
  },
  data() {
    return {
      selected: []
    }
  },
  mounted() {
    this.selected = this.items.reduce((prev, curr) =>
        this.initSelected.includes(curr.id)
          ? [ ...prev, curr.id ]
          : [ ...prev ]
      , [])
    this.initProducts()
  },
  methods: {
    ...mapActions(['initProducts']),
    isItemDisabled(item){
      // Items are disabled if they have a group already, or they are one of the preselected ones
      return !isEmpty(item.scheduleGroup)
        && !this.initSelected.includes(item.id)
    }
  },
}
</script>
